<template>
  <div class="mineInfo">
    <template v-if="userInfo">
      <TopPanel>个人信息</TopPanel>
      <div id="info">
        <div id="lblHeadPic" class="common">头像</div>
        <div class="avatar">
          <img :src="displayImage" />
        </div>
        <div id="lblEdit" @click="openDialog">修改</div>
        <div id="lblRemark">头像限制为400*400,100KB</div>
      </div>
      <div id="nickrow">
        <div id="lblNick">昵称</div>
        <input id="txtNick" type="text" v-model="nick" />
      </div>
      <a class="btn" href="javascript:'" @click="updateAvatarNick">提交</a>
    </template>
    <template>
      <el-dialog
        title="头像设置"
        :visible.sync="dialogVisible"
        width="30%"
        center
      >
        <div>
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :accept="'image/*'"
          >
            <img v-if="imageUrl" :src="imageUrl" class="upavatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <span id="uploadRemark"
          >可上传的图片格式：jpg、jpeg、png，图片大小 不超过2M</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="selectImage">确定</el-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import Urls from '@/assets/js/Urls'
import { updateUserNickAvatar } from '@/api/account'
import TopPanel from '@/components/Mine/TopPanel'
export default {
  name: 'MineInfo',
  components: { TopPanel },
  data() {
    return {
      data: {},
      dialogVisible: false,
      uploadUrl: `${Urls.DOMAIN_STATIC}/Upload/Image`,
      imageUrl: null,
      nick: null
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    displayImage() {
      if (this.imageUrl) {
        return this.imageUrl
      } else {
        return this.userInfo.avatar
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      this.$store.dispatch('user/getUserInfo').then(() => {
        this.nick = this.userInfo.nick
      })
    },
    openDialog() {
      this.dialogVisible = true
    },
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw)
      this.imageUrl = res.result.code === 0 ? res.detail : null
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/JPEG/PGN 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    selectImage() {
      if (this.imageUrl) {
        // this.userInfo.avatar = this.imageUrl
      }
      this.dialogVisible = false
    },
    updateAvatarNick() {
      if (this.imageUrl || this.nick) {
        let img = null
        if (this.imageUrl) {
          img = this.imageUrl
        } else {
          img = this.userInfo.avatar
        }
        const result = updateUserNickAvatar(img, this.nick)
        if (result) {
          this.$message.info('修改成功')
          setInterval(() => {
            history.go(0)
          }, 500)
        }
      } else {
        this.$message.error('要上传的图片或者昵称不能为空！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mineInfo {
  width: 768px;
  height: 1121px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 40px;
}

.common {
  font-family: MicrosoftYaHei;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 1px;
  color: #262626;
  margin-left: 30px;
}

#lblHeadPic {
  font-size: 14px;
  font-weight: normal;
}

#info {
  display: flex;
  height: 96px;
  align-items: center;
  margin-top: 30px;
}
.avatar {
  margin-left: 40px;
}
img {
  width: 96px;
  height: 96px;
  border-radius: 50%;
}
#impUpload {
  width: 180px;
  height: 180px;
  margin: 10px auto;
  display: block;
}
#nickrow {
  display: flex;
  height: 40px;
  margin-left: 30px;
  margin-top: 30px;
  align-items: center;
}
#lblEdit {
  margin-left: 40px;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 1px;
  color: #046bcc;
  cursor: pointer;
}
#lblRemark {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 1px;
  color: #858585;
  margin-left: 40px;
}
#lblNick {
  font-size: 14px;
}
#txtNick {
  width: 180px;
  height: 40px;
  background-color: #fafafa;
  border-radius: 5px;
  border: solid 1px #ebebeb;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 1px;
  color: #262626;
  padding-left: 16px;
  margin-left: 40px;
}

.btn {
  display: inline-block;
  width: 120px;
  height: 40px;
  background-color: #046bcc;
  border-radius: 5px;
  text-decoration: none;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 1px;
  color: #ffffff;
  text-align: center;
  margin-left: 99px;
  margin-top: 30px;
}
#btnUpload {
  display: block;
  width: 80px;
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  margin: 5px auto;
  border-radius: 5px;
  background-color: #046bcc;
  text-decoration: none;
  text-align: center;
}
abtn {
  display: inline-block;
  background-color: #046bcc;
  color: #ffffff;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
}
#uploadRemark {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #858585;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: block;
  width: 178px;
  margin: 5px auto;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.upavatar {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
